'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _media = require('../media');

var _media2 = _interopRequireDefault(_media);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Match = function (_Component) {
    _inherits(Match, _Component);

    function Match(props) {
        _classCallCheck(this, Match);

        var _this = _possibleConstructorReturn(this, (Match.__proto__ || Object.getPrototypeOf(Match)).call(this, props));

        _this.onBreakpoint = _this.onBreakpoint.bind(_this);

        _this.state = { mq: '' };
        return _this;
    }

    _createClass(Match, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _media2.default.listenBreakpoint(this.onBreakpoint);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _media2.default.unlistenBreakpoint(this.onBreakpoint);
        }
    }, {
        key: 'onBreakpoint',
        value: function onBreakpoint(query_name) {
            this.setState({
                mq: query_name
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var show = this.props.show;
            var mq = this.state.mq;


            if (show && show.split(',').filter(function (name) {
                return name.trim() === mq;
            }).length == 0) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                _extends({ className: 'fluid-react-breakpoint' }, this.props),
                this.props.children
            );
        }
    }]);

    return Match;
}(_react.Component);

exports.default = Match;


/*****************
 ** WEBPACK FOOTER
 ** ./~/fluid-react/dist/css/Match.js
 ** module id = 763
 ** module chunks = 0
 **/